define((require) => {
    "use strict";

    const ChunkingCollection  = require("data/ChunkingCollection");
    const RestApi             = require("shared/services/RestApi");
    const SyncManager         = require("shared/services/sync/SyncManager");
    const TemplateModel       = require("ui/experience/TemplateModel");

    // Defined supported (polymorphic) types/models.
    const contentTypes = new Map();

    // This is most likely not the right model.
    contentTypes.set(TemplateModel.type, TemplateModel);

    /**
     *
     * @class TemplateCollection
     *
     * @type {*|void}
     */
    const TemplateCollection = ChunkingCollection.extend({

        model: contentTypes,

        url() {
            return RestApi.pathToCollection(RestApi.Collections.TEMPLATES);
        }

    }, {

        /**
         * Counts the entire template collection.
         *
         * @return {Promise}        A <tt>Promise</tt> that resolves with the count/number.
         */
        count() {
            return SyncManager.get(RestApi.pathToCollection(RestApi.Collections.TEMPLATES_COUNT), SyncManager.target("TemplateCollection.count"));
        }

    });

    return TemplateCollection;
});



// WEBPACK FOOTER //
// ./src/editor/data/TemplateCollection.js